module.exports = __webpack_public_path__ + "media/img/landing/banner-1f02eb9bfe28d42efd9fd784b09ddb36.jpg";